var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCiChartLine(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 15V16.8C3 17.92 3 18.48 3.218 18.908C3.40974 19.2843 3.71569 19.5903 4.092 19.782C4.519 20 5.079 20 6.197 20H21M3 15V5M3 15L6.853 11.79L6.857 11.787C7.554 11.206 7.903 10.915 8.282 10.797C8.72913 10.6572 9.21116 10.6788 9.644 10.858C10.011 11.011 10.332 11.332 10.976 11.976L10.982 11.982C11.636 12.636 11.963 12.964 12.336 13.115C12.7774 13.2949 13.2686 13.3112 13.721 13.161C14.104 13.033 14.454 12.727 15.154 12.115L21 7",
    stroke: "#3B82F6",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCiChartLine);
export default __webpack_public_path__ + "static/media/ci_chart-line.54d9053ae7233e95a90371b03f5c58e9.svg";
export { ForwardRef as ReactComponent };